export enum NavCategoryContext {
  LandingPage = 'LandingPage',
  CollectionsPage = 'CollectionsPage',
  MobileMenu = 'MobileMenu',
  DesktopMenu = 'DesktopMenu',
  Footer = 'Footer',
}
